import React, { useEffect, useRef, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import SearchIcon from "@mui/icons-material/Search";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useDispatch } from "react-redux";
import { styled } from "@mui/system";
import InputBase from "@mui/material/InputBase";
import CloseIcon from "@mui/icons-material/Close";
import { logout } from "../../store/slices/authSlice";
import { useSearch } from "../../context/SearchContext";
import Notification from "../shared/Notification";
import { Link } from "@mui/icons-material";
const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  border: "1px solid white",
  backgroundColor: "transparent",
  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.1)",
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(3),
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const ClearIconWrapper = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  right: 0,
  top: 0,
  bottom: 0,
  marginRight: theme.spacing(1),
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    paddingRight: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "15ch",
      "&:focus": {
        width: "25ch",
      },
    },
  },
}));

const ToolbarGroup = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
}));

const ToolbarSpacer = styled("div")({
  flexGrow: 1,
});

const StyledIconButton = styled(IconButton)({
  marginRight: "5px",
});

const TopToolbar = ({ handleDrawerToggle }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const dispatch = useDispatch();
  const { searchTerm, setSearchTerm } = useSearch();
  const [anchorEl, setAnchorEl] = useState(null);
  const [notificationOpen, setNotificationOpen] = useState(false);
  const base64Image = localStorage.getItem(`clientLogo`);
  const clientLogoRef = useRef(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    dispatch(logout());
    handleMenuClose();
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleClearSearch = () => {
    setSearchTerm("");
  };

  useEffect(() => {
    if (base64Image && clientLogoRef.current) {
      clientLogoRef.current.src = `data:image/png;base64,${base64Image}`;
    }
  }, [base64Image]);

  return (
    <>
      <AppBar
        position="fixed"
        color="primary"
        sx={{
          boxShadow: "0px 4px 6px 0px #00000040",
          zIndex: theme.zIndex.drawer + 1,
        }}
      >
        <Toolbar>
          <ToolbarGroup>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={handleDrawerToggle}
              sx={{ mr: 2, display: { sm: "none" } }}
            >
              <MenuIcon />
            </IconButton>
            {!isMobile && (
              <div
                style={{ display: "flex", alignItems: "center", gap: "20px" }}
              >
                <img
                  src={require("../../assets/images/nexus_logo.png")}
                  alt="Logo"
                  style={{
                    width: "130px",
                    maxHeight: "50px",
                  }}
                />
                {base64Image && base64Image !== "null" && (
                  <>
                    <Link />
                    <img
                      id="clientLogo"
                      ref={clientLogoRef}
                      alt="Client Logo"
                      style={{
                        width: "130px",
                        maxHeight: "50px",
                      }}
                    />
                  </>
                )}
              </div>
            )}
            <Search>
              <SearchIconWrapper>
                <SearchIcon />
              </SearchIconWrapper>
              <StyledInputBase
                placeholder="Search…"
                inputProps={{ "aria-label": "search" }}
                value={searchTerm}
                onChange={handleSearchChange}
              />
              {searchTerm && (
                <ClearIconWrapper onClick={handleClearSearch}>
                  <CloseIcon style={{ filter: "invert(1)" }} />
                </ClearIconWrapper>
              )}
            </Search>
          </ToolbarGroup>
          <ToolbarSpacer />
          <ToolbarGroup>
            <StyledIconButton color="inherit">
              <NotificationsIcon />
            </StyledIconButton>
            <StyledIconButton
              edge="end"
              color="inherit"
              aria-controls="account-menu"
              aria-haspopup="true"
              onClick={handleMenuOpen}
            >
              <AccountCircle />
            </StyledIconButton>
            <Menu
              id="account-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              sx={{
                "& .MuiPaper-root": {
                  backgroundColor: "#000000",
                  color: "#ffffff",
                },
              }}
            >
              <MenuItem onClick={handleLogout}>Log Out</MenuItem>
            </Menu>
          </ToolbarGroup>
        </Toolbar>
      </AppBar>
      <Notification
        open={notificationOpen}
        message="This is a long running process and will run in the background!"
        severity="info"
        handleClose={() => setNotificationOpen(false)}
      />
    </>
  );
};

export default TopToolbar;
